import { CampanhaRepresentante } from '../campanha-representante';

export class CampanhaRepresentantePopula {
    selected: boolean;
    exist: boolean;
    campanhaRepresentante: CampanhaRepresentante;
}
